import type { ContentType, Picture, UrlsInText } from './common'
import type { User } from './user'

export type DecorationsClass = {}

export enum CommentStatus {
	NORMAL = 'NORMAL',
	DELETED = 'DELETED',
}

export type CommentTargetType = ContentType
export type CommentListOrder = 'LIKES' | 'TIME'

export interface Comment {
	type: string
	id: string
	targetType: CommentTargetType
	targetId: string
	threadId: string
	createdAt: string
	level: number
	content: string
	urlsInText: UrlsInText[]
	endowCount: number
	endowerCount: number
	endowed: boolean
	likeCount: number
	replyCount: number
	status: CommentStatus
	user: User
	pictures: Picture[]
	liked: boolean
	deleted?: boolean
	enablePictureComments: boolean
	readTrackInfo: DecorationsClass
	collapsed: boolean
	collapsible: boolean
	isPinned: boolean
	pinnable: boolean
	replyToComment?: Comment
	hotReplies?: Comment[]
}
